// extracted by mini-css-extract-plugin
export var cardIcon = "_6p-4";
export var checkboxCard = "_6p-0";
export var checkboxCardSelected = "_6p-3";
export var disabled = "_6p-1";
export var outerBorder = "_6p-2";
export var spacerMedium = "_6p-7";
export var spacerSmall = "_6p-6";
export var spacerXsmall = "_6p-5";